export function applyLoader(opts = {}) {
  const t = setTimeout(() => {
    const { MainLoader } = this.getRoot()
     
    if (opts.value !== undefined) {
      // Route through `root.update()` so the signal-tracked binding fires.
      // Direct `getRootState().loading = …` mutation bypasses smbls 3.14
      // reactivity (typed-bag schema gates writes through `update()`).
      this.getRoot().update({ loading: opts.value })
    }
    const isLoading = this.getRootState('loading')

    if (opts.force) {
      if (isLoading) {
        MainLoader.update({ animation: 'scaleOutIn', animationDelay: '0' })

        // const troubleShootingTimeout = setTimeout(() => {
        //   if (this.getRootState('loading') && this.getCanvasScope()) {
        //     this.call('openNotification', {
        //       title: 'Taking a while?',
        //       message:
        //         'Please hold on for a moment or consider going back to the dashboard.',
        //       type: 'warning',
        //       href: '/dashboard'
        //     })
        //   }
        //   clearTimeout(troubleShootingTimeout)
        // }, 7500)
      } else {
        MainLoader.update({ animation: 'scaleInOut', animationDelay: 'F' })
      }
      clearTimeout(t)
      return
    }

    if (isLoading === null || !MainLoader) {
      clearTimeout(t)
      return
    }

    const loaderAnimation = MainLoader.animation

    if (isLoading === true) {
      if (loaderAnimation !== 'scaleOutIn') {
        MainLoader.update({ animation: 'scaleOutIn', animationDelay: '0' })
      }
    } else if (isLoading === false) {
      if (loaderAnimation !== 'scaleInOut') {
        MainLoader.update({ animation: 'scaleInOut', animationDelay: 'F' })
      }
    } else if (loaderAnimation !== 'scaleInOut') {
      MainLoader.update({ animation: 'scaleInOut', animationDelay: 'F' })
    }
    clearTimeout(t)
  }, opts.timeout || 150)
}

// if (isLoading === true) {
//   if (loaderAnimation !== 'scaleOutIn') {
//     Loader.update({ animation: 'scaleOutIn', animationDelay: '0' })
//   }
// } else if (isLoading === false) {
//   if (loaderAnimation !== 'scaleInOut') {
//     Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
//   }
// } else if (loaderAnimation !== 'scaleInOut') {
//   Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
// }
